'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  .tippy-tooltip {\n    color: ', ';\n    background-color: ', ';\n    font-size: 1em;\n    border-radius: ', ';\n  }\n\n  .tippy-popper[x-placement^=top] [x-arrow] {\n    border-top-color: ', ' !important;\n  }\n  .tippy-popper[x-placement^=right] [x-arrow] {\n    border-right-color: ', ' !important;\n  }\n  .tippy-popper[x-placement^=bottom] [x-arrow] {\n    border-bottom-color: ', ' !important;\n  }\n  .tippy-popper[x-placement^=left] [x-arrow] {\n    border-left-color: ', ' !important;\n  }\n'], ['\n  .tippy-tooltip {\n    color: ', ';\n    background-color: ', ';\n    font-size: 1em;\n    border-radius: ', ';\n  }\n\n  .tippy-popper[x-placement^=top] [x-arrow] {\n    border-top-color: ', ' !important;\n  }\n  .tippy-popper[x-placement^=right] [x-arrow] {\n    border-right-color: ', ' !important;\n  }\n  .tippy-popper[x-placement^=bottom] [x-arrow] {\n    border-bottom-color: ', ' !important;\n  }\n  .tippy-popper[x-placement^=left] [x-arrow] {\n    border-left-color: ', ' !important;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTippy = require('react-tippy');

require('react-tippy/dist/tippy.css');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('../../styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

// eslint-disable-next-line no-unused-expressions
(0, _styledComponents.injectGlobal)(_templateObject, _styles2.default.white, _styles2.default.black, _styles2.default.inputBorderRadius, _styles2.default.black, _styles2.default.black, _styles2.default.black, _styles2.default.black);

var Content = _styledComponents2.default.div.withConfig({
  displayName: 'Tooltip__Content'
})(['width:auto;max-width:256px;padding:1.5rem;color:', ';background-color:', ';text-align:center;font-weight:600;border-radius:', ';opacity:0.9;> header{margin-bottom:', ';color:', ';font-weight:700;&:after{content:\'\';display:block;width:100%;max-width:8rem;height:2px;margin:1.5rem auto;background-color:', ';}}'], _styles2.default.grayLighter, _styles2.default.black, _styles2.default.inputBorderRadius, function (p) {
  return p.hasContent ? '1rem' : 0;
}, _styles2.default.white, _styles2.default.gray);

var Tooltip = function Tooltip(_ref) {
  var title = _ref.title,
      html = _ref.html,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['title', 'html', 'children']);

  return _react2.default.createElement(
    _reactTippy.Tooltip,
    _extends({
      trigger: 'mouseenter',
      position: 'top',
      arrow: 'true',
      delay: 500,
      html: _react2.default.createElement(
        Content,
        { hasContent: html },
        title && _react2.default.createElement(
          'header',
          null,
          title
        ),
        html && _react2.default.createElement(
          'main',
          null,
          html
        )
      )
    }, rest),
    children
  );
};

Tooltip.propTypes = process.env.NODE_ENV !== "production" ? _extends({
  html: _propTypes2.default.node.isRequired,
  title: _propTypes2.default.node,
  children: _propTypes2.default.node.isRequired
}, _reactTippy.Tooltip.propTypes) : {};

exports.default = Tooltip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/next/Tooltip/Tooltip.js
// module id = 903
// module chunks = 14